module.exports = __webpack_public_path__ + "img/3.e6e91f91.jpg";